/* Vadim R - mobile and desktop hero carousel. Unpublished draft. */
(function () {
  "use strict";
  var SELECTOR = '.vmr-h[data-vmr-carousel]';
  var TIME = 2500;

  function init(root) {
    if (root.dataset.vmrInitialized === '1') return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-vmr-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-vmr-go]'));
    var toggle = root.querySelector('[data-vmr-toggle]');
    if (slides.length !== 4 || dots.length !== slides.length || !toggle) return;

    root.dataset.vmrInitialized = '1';
    var current = 0;
    var timer = null;
    var manualPause = false;
    var focused = false;
    var hovered = false;
    var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var touchX = null;
    var touchY = null;

    function pauseTimer() {
      if (timer !== null) { window.clearInterval(timer); timer = null; }
    }
    function imageFor(index) {
      var el = slides[index].querySelector('img');
      if (el) el.loading = 'eager';
    }
    function show(index) {
      current = (index + slides.length) % slides.length;
      imageFor(current);
      imageFor((current + 1) % slides.length);
      slides.forEach(function (slide, i) {
        var active = i === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach(function (button, i) {
        var active = i === current;
        button.classList.toggle('is-active', active);
        if (active) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
    }
    function canPlay() {
      return !manualPause && !motion.matches && !document.hidden && !focused;
    }
    function sync() {
      focused = !!root.querySelector(':focus-visible');
      pauseTimer();
      if (canPlay()) timer = window.setInterval(function () { show(current + 1); }, TIME);
    }
    function updateToggle() {
      toggle.textContent = manualPause ? '\u25b6' : '\u2161';
      toggle.setAttribute('aria-label', manualPause ? root.dataset.vmrPlayLabel : root.dataset.vmrPauseLabel);
      toggle.setAttribute('aria-pressed', manualPause ? 'true' : 'false');
    }

    dots.forEach(function (button, index) {
      button.addEventListener('click', function () { show(index); sync(); });
    });
    toggle.addEventListener('click', function () {
      manualPause = !manualPause;
      updateToggle();
      sync();
    });
    root.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1) return;
      touchX = event.touches[0].clientX;
      touchY = event.touches[0].clientY;
    }, {passive: true});
    root.addEventListener('touchend', function (event) {
      if (touchX === null || !event.changedTouches.length) return;
      var dx = event.changedTouches[0].clientX - touchX;
      var dy = event.changedTouches[0].clientY - touchY;
      touchX = touchY = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > 1.4 * Math.abs(dy)) {
        show(current + (dx < 0 ? 1 : -1));
        sync();
      }
    }, {passive: true});
    if (window.matchMedia('(hover: hover)').matches) {
      root.addEventListener('mouseenter', function () { hovered = true; sync(); });
      root.addEventListener('mouseleave', function () { hovered = false; sync(); });
    }
    root.addEventListener('focusin', function () { focused = true; sync(); });
    root.addEventListener('focusout', function () {
      window.requestAnimationFrame(function () {
        focused = root.contains(document.activeElement);
        sync();
      });
    });
    document.addEventListener('visibilitychange', sync);
    if (motion.addEventListener) motion.addEventListener('change', sync);
    else if (motion.addListener) motion.addListener(sync);

    show(0);
    updateToggle();
    sync();
  }
  function scan(context) {
    var node = context || document;
    if (node.matches && node.matches(SELECTOR)) init(node);
    node.querySelectorAll(SELECTOR).forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); }, {once: true});
  } else scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();
